module.exports = __webpack_public_path__ + "img/group-details.637c2c69.png";